import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";

import { parseMoney } from "../../../Utils/Functions";

export const SEASONS_QUERY = gql`
	query seasons {
		seasons {
			id
			name
		}
	}
`;

export const FRAGMENT_TEMPORAL_SEASONS = new FragmentDefiner(
	"Property",
	`
  seasons {
    id
    name
    slug
    rental_data {
      price
      currency {
        name
      }
    }
  }
`
);

const SEND_LEAD_MUTATION = gql`
	mutation sendLead($input: LeadInput!) {
		sendLead(input: $input) {
			id
		}
	}
`;

interface TemporaryRentalHook {
	data: SeasonRow[];
	sendLead: Function;
	loading: Boolean;
}

interface SeasonRow {
	title: string;
	value: Number;
	slug: string;
}

export const useTemporaryRental = ({ id }): TemporaryRentalHook => {
	const { loading: temporalLoading, data: temporalData, error: temporalError } = useReadFragment(
		FRAGMENT_TEMPORAL_SEASONS,
		id
	);
	const { loading: seasonLoading, data: seasonData, error: seasonError } = useQuery(
		SEASONS_QUERY
	);
	const [data, setData] = useState([]);

	const [sendLeadMutation] = useMutation(SEND_LEAD_MUTATION, {
		onError: error => {
			console.error(error);
		},
	});

	const sendLead = async (field: string) => {
		return sendLeadMutation({
			variables: {
				input: {
					type: "PROPERTY",
					property_id: id,
					message: `Me gustaria saber el precio de esta propiedad para la temporada: ${field}`,
					source: 14,
					isAutoGenerated: true,
					financing_information: false,
				},
			},
		});
	};

	useEffect(() => {
		if (temporalData && seasonData) {
			let newData = [];
			seasonData.seasons.forEach(season => {
				let seasonIndex = temporalData.seasons.findIndex(e => e.id == season.id);
				if (seasonIndex >= 0) {
					newData.push({
						title: season.name,
						slug: season.slug,
						value: `${
							temporalData.seasons[seasonIndex].rental_data.currency.name
						} ${parseMoney(temporalData.seasons[seasonIndex].rental_data.price)}`,
					});
				} else {
					newData.push({
						title: season.name,
						slug: season.slug,
						value: 0,
					});
				}
			});
			setData(newData);
		}
	}, [temporalData, seasonData]);

	return {
		data,
		sendLead,
		loading: seasonLoading,
	};
};
